import React, { useMemo } from 'react';
import useQueryParamsFilter from 'Shared/hooks/useQueryParamsFilter';
import Button from 'Components/Admin/Button';
import DirectionIndicatorSVG from 'Components/Admin/assets/DirectionIndicatorSVG';
import ArrowBackSVG from 'Components/Admin/assets/ArrowBackSVG';

const CustomFooter = ({ onSuccess, step, setStep, totalPagesCount, formProps, formItems = [] }) => {
  const currentStepFields = useMemo(() => {
    return formItems.reduce((obj, item) => {
      if (Array.isArray(item)) {
        item.forEach(subItem => obj[subItem.name] = true);
      }

      obj[item.name] = true;

      return obj;
    }, {});
  }, [step, formItems]);

  const validateStep = () => {
    return new Promise((resolve) => {
      formProps.validateForm()
        .then((invalidFields) => {
          formProps.setTouched(currentStepFields);

          if (!Object.keys(invalidFields).some(key => key in currentStepFields)) resolve();
        });
    });
  };

  const handleNextStep = () => {
    validateStep().then(() => {
      setStep({ step: step + 1 });
    });
  };

  const handlePrevStep = () => setStep({ step: step - 1 });

  return (
    <div className="sub-form__footer_pagination">
      <div className="sub-form__btn-group">
        {
          step > 1 && (
            <Button onClick={handlePrevStep} className="sub-form__btn_back"><ArrowBackSVG /> Back</Button>
          )
        }
        {
          step === totalPagesCount && (
            <Button onClick={onSuccess} className="sub-form__btn" variant="primary">Save</Button>
          )
        }
        {
          step < totalPagesCount && (
            <Button onClick={handleNextStep} className="sub-form__btn" variant="primary">Next</Button>
          )
        }
      </div>
      <div className="sub-form__indicators">
        <DirectionIndicatorSVG direction={step >= totalPagesCount ? 'prev' : 'next'} />
      </div>
    </div>
  );
};

const withPagination = (SubForm) => {
  return ({ items: pages, ...props }) => {
    const [{ step }, setPagination, { isInitialized }] = useQueryParamsFilter({ step: 1 });

    const formItems = useMemo(() => {
      return pages[step - 1].items;
    }, [step, pages]);

    if (!isInitialized) return null;

    return (
      <SubForm
        {...props}
        items={formItems}
        renderCustomFooter={(props) => (
          <CustomFooter
            {...props}
            setStep={setPagination}
            step={step}
            totalPagesCount={pages.length}
            formItems={formItems}
          />
        )}
      />
    );
  };
};

export default withPagination;
